import { OmniViewMode } from './omnidashboard.config';

export interface ColorPair {
  bg: string;
  text: string;
}

export interface SiteColumn {
  siteName: string;
}

export interface ErgRow {
  bpgName: string;
}

export interface ChapterInfo {
  chapterId: number;
  siteName: string;
  bpgName: string;
}

export interface SummaryEntry {
  value: string;
  label: string;
  count: number;
  bg: string;
  text: string;
  tooltip: string;
  iconClass: string;
}

export const SUMMARY_VALUE_NA = '__NA__';

export interface LegendEntry {
  label: string;
  bg: string;
  text: string;
}

export interface AcknowledgementStatusEntry {
  chapterId: number;
  siteName?: string;
  bpgName?: string;
  executiveSponsorSigned: string | null;
  chairSigned: string | null;
  coChairSigned: string | null;
  modifiedSponsorSignedDate?: string | null;
  modifiedChairSignedDate?: string | null;
  modifiedCoChairSignedDate?: string | null;
}

export interface AcknowledgementMatrixStatus {
  statusLabel: 'Complete' | 'Partially Signed' | 'Not Started';
  displayValue: string;
  color: ColorPair;
  signedCount: number;
}

export interface MetricData {
  displayValue: string;
  color: ColorPair;
  value: string | null;
  signedCount?: number;
}

export type MatrixCellData = ChapterInfo & {
  metrics: Map<string, MetricData>;
};

export interface ResolvedCellDisplay {
  bg: string;
  text: string;
  displayValue: string;
  tooltip: string;
}

export interface OmniVisibleCell {
  key: string;
  site: SiteColumn;
  cell: MatrixCellData;
  resolved: ResolvedCellDisplay;
}

export interface OmniVisibleRow {
  erg: ErgRow;
  cells: OmniVisibleCell[];
}

export interface MetricSummaryBucket {
  value: string;
  label: string;
  color: ColorPair;
  tooltip: string;
  iconClass: string;
}

export interface OmniMetricDefinition {
  key: OmniViewMode;
  label: string;
  legend: LegendEntry[];
  summaryBuckets: MetricSummaryBucket[];
  naMetric: MetricData;
  tooltipFormatter?: (cell: MatrixCellData, metric: MetricData) => string;
}

export type AnnualPlanRawStatus = 'NEW' | 'DRAFT' | 'SUBMITTED' | 'APPROVED' | 'REJECTED';

export interface AnnualPlanStatusEntry {
  chapterId: number;
  budgetStatus: AnnualPlanRawStatus;
}

export type AnnualPlanDisplayLabel =
  | 'Approved' | 'Submitted' | 'Draft' | 'New' | 'Rejected' | 'No Data';

export interface AnnualPlanMatrixStatus {
  statusLabel: AnnualPlanDisplayLabel;
  displayValue: string;
  color: ColorPair;
}
